module.exports = __webpack_public_path__ + "static/settings-adbc179c7eba340002cecc13939299af.png";